import { Badge, Checkbox } from '@/components/ui';
import { cn } from '@/utils/cn';

/**
 * Skills read out of a CV, as tick boxes.
 *
 * A skill already on the profile is shown greyed rather than hidden, so the
 * student can see that we did read it and chose not to duplicate it. "New to
 * the catalogue" is worth flagging: accepting it adds an entry nobody has
 * curated yet, which is allowed but should not be silent.
 */
export function SkillProposals({ skills, selected, onToggle }) {
  if (skills.length === 0) {
    return (
      <p className="text-ink-muted text-sm">
        No skills we could identify. Listing them under a “Skills” heading is what makes them
        findable.
      </p>
    );
  }

  return (
    <ul className="flex flex-wrap gap-2">
      {skills.map((skill) => {
        const taken = skill.already_on_profile;
        return (
          <li key={skill.name}>
            <label
              className={cn(
                'ring-line flex items-center gap-2 rounded-full py-1 pr-3 pl-2.5 text-sm ring-1',
                taken
                  ? 'bg-surface-muted text-ink-muted'
                  : 'bg-surface text-ink hover:ring-brand-300 cursor-pointer',
              )}
            >
              {taken ? (
                <span className="border-line block size-4 rounded border" aria-hidden />
              ) : (
                <Checkbox
                  checked={selected.includes(skill.name)}
                  onChange={() => onToggle(skill.name)}
                  aria-label={`Add ${skill.name}`}
                />
              )}
              <span>{skill.name}</span>
              {!taken && !skill.is_known && <Badge tone="warning">New</Badge>}
              {taken && <Badge>Have it</Badge>}
            </label>
          </li>
        );
      })}
    </ul>
  );
}
